import { createActions, createReducer } from 'reduxsauce'

import ConsultaVacanciasService from '../../servicos/ConsultaRemuneracaoADMRHService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaVacanciasInicio: [],
    buscaConsultaVacanciasErro: ['erro'],
    buscaConsultaVacanciasSucesso: ['consultaVacancias'],
    limpar: [],
    setConsultaVacanciasEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaConsultaVacancias = (filtro, tipoServidor) => {
    return dispatch => {
        dispatch(Creators.buscaConsultaVacanciasInicio())
        let serv = new ConsultaVacanciasService()
        return serv
            .consultarVacancias(filtro, tipoServidor)
            .then(response => dispatch(Creators.buscaConsultaVacanciasSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaVacanciasErro(error)))
    }
}

const buscaConsultaVacanciasInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaVacanciasErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaConsultaVacanciasSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaVacancias.resultado,
        dataSincronizacaoDados: action.consultaVacancias.dataSincronizacaoDados,
        carregando: false,
        fonte: action.consultaVacancias.fonte,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaVacanciasEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_VACANCIAS_INICIO]: buscaConsultaVacanciasInicio,
    [Types.BUSCA_CONSULTA_VACANCIAS_ERRO]: buscaConsultaVacanciasErro,
    [Types.BUSCA_CONSULTA_VACANCIAS_SUCESSO]: buscaConsultaVacanciasSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_VACANCIAS_ESTADO_DT]: setConsultaVacanciasEstadoDT,
})
